import { useTranslation } from 'react-i18next';

/**
 * Возможности курса — тумблеры в настройках курса (`MarathonSettingsTab`, «Возможности курса»).
 *
 * До 13.10.2026 список жил в окне тарифа (`TariffModal.tsx`). Решение владельца 13.10: раздел «Тарифы» в админке
 * убран целиком (пункт меню, маршрут, страница, окно); тарифы в базе и права по ним не тронуты. Список возможностей
 * нужен и без раздела — его читают настройки курса, поэтому он переехал сюда. Подписи — ключи `tariff.feature*`
 * (имя раздела локалей историческое, на экран не выходит).
 */
export type CourseFeatureFlag = { id: string; label: string };

export function useCourseFeatureFlags() {
  const { t } = useTranslation();
  const featureFlags: CourseFeatureFlag[] = [
    { id: 'lessons', label: t('tariff.featureLessons') },
    { id: 'live', label: t('tariff.featureLive') },
    { id: 'attendance', label: t('tariff.featureAttendance') },
    { id: 'speaking_peers', label: t('tariff.featureSpeakingPeers') },
    { id: 'speaking_ai', label: t('tariff.featureSpeakingAI') },
    { id: 'chat', label: t('tariff.featureChat') },
    { id: 'vocab', label: t('tariff.featureVocab') },
    { id: 'cefr', label: t('tariff.featureCefr') },
    // ⚠️ ОБЩИЙ КЛЮЧ ОСТАЁТСЯ РАДИ СТАРЫХ ЗАПИСЕЙ, но включать его в новых не нужно: он означает «все тренажёры
    // сразу» и без отдельных ключей раскрывается во все шесть. Подпись прямо про это говорит.
    { id: 'ielts', label: t('tariff.featureIelts') },
    // Проверка письменных работ отделена от `ielts` 24.08.2026: чтение и слушание почти ничего не стоят, а разбор
    // эссе — самая дорогая операция после живого голоса.
    { id: 'ielts_reading', label: t('tariff.featureIeltsReading') },
    { id: 'ielts_listening', label: t('tariff.featureIeltsListening') },
    { id: 'ielts_writing', label: t('tariff.featureIeltsWriting') },
    { id: 'ielts_speaking', label: t('tariff.featureIeltsSpeaking') },
    { id: 'mock', label: t('tariff.featureMock') },
    // Спринт — свой тумблер: у Pre-Upper его нет вовсе (решение заказчика 04.09.2026).
    { id: 'sprint', label: t('tariff.featureSprint') },
    { id: 'writing_ai', label: t('tariff.featureWritingAI') },
  ];
  return { featureFlags };
}
